import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { DATA_VIZ_COLORS } from "../../../config/chartColors";
import type { ReviewTimePattern } from "../../../generated/graphql";

interface ReviewTimeChartProps {
  data: ReviewTimePattern[];
}

export function ReviewTimeChart({ data }: ReviewTimeChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty">No review time pattern data available</div>
      </div>
    );
  }

  const chartData = data.map((pattern) => ({
    hour: `${pattern.hour}:00`,
    reviews: pattern.reviewCount,
    accuracy: pattern.averageAccuracy.toFixed(1),
  }));

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h4 className="h6">Review Time Patterns</h4>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="hour"
              label={{ value: "Hour of Day", position: "insideBottom", offset: -5 }}
            />
            <YAxis label={{ value: "Review Count", angle: -90, position: "insideLeft" }} />
            <Tooltip />
            <Legend />
            <Bar dataKey="reviews" fill={DATA_VIZ_COLORS.primary} name="Reviews" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
